import React, { useState, useEffect } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Checkbox from "@mui/material/Checkbox"
import CssBaseline from "@mui/material/CssBaseline"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import FormControl from "@mui/material/FormControl"
import Link from "@mui/material/Link"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import MuiCard from "@mui/material/Card"
import { styled } from "@mui/material/styles"
import ForgotPassword from "./ForgotPassword"
import ColorModeSelect from "../../theme/ColorModeSelect"
import logo from "../../assets/images/logo.jpeg"
import { InputAdornment } from "@mui/material"
import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import { login } from "../../redux/Slice/AuthSlice"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, useNavigate } from "react-router-dom"
import { clearMessage } from "../../redux/Slice/message"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { toast } from "sonner"
import Grid from "@mui/material/Grid2"
import signinleft from "../../assets/images/signinleft.png"
import background from "../../assets/images/signinbg.png"

// const Card = styled(MuiCard)(({ theme }) => ({
//   display: "flex",
//   flexDirection: "column",
//   alignSelf: "center",
//   width: "100%",
//   padding: theme.spacing(4),
//   gap: theme.spacing(2),
//   margin: "auto",
//   [theme.breakpoints.up("sm")]: {
//     maxWidth: "450px",
//   },
//   boxShadow: "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
//   ...theme.applyStyles("dark", {
//     boxShadow: "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
//   }),
// }))

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: 2,
  backgroundColor: "white",
  color: "black",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    // backgroundImage: "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    // backgroundRepeat: "no-repeat",
    // ...theme.applyStyles("dark", {
    //   backgroundImage: "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    // }),
  },
}))

export default function SignIn(props) {
  const [emailError, setEmailError] = useState(false)
  const [emailErrorMessage, setEmailErrorMessage] = useState("")
  const [passwordError, setPasswordError] = useState(false)
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
  const [open, setOpen] = useState(false)

  const [showPassword, setShowPassword] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [selectedEmail, setSelectedEmail] = useState("")
  const [selectedPassword, setSelectedPassword] = useState("")

  useEffect(() => {
    const rememberedUsers = JSON.parse(localStorage.getItem("rememberedUsers")) || []

    if (rememberedUsers.length > 0) {
      const userEmails = rememberedUsers.map((user) => user.email)
      setSuggestions(userEmails)
    }
  }, [])

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isLoggedIn } = useSelector((state) => state.auth)

  const message = useSelector((state) => state.message)

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCheckboxChange = (event) => {
    //rememberme
    setRememberMe(event.target.checked)
  }

  const handleEmailFocus = () => {
    setShowSuggestions(true)
  } //multi remember user dropdown

  const handlePassChange = (event) => {
    setSelectedPassword(event.target.value)
  }
  const handleEmailChange = (event) => {
    setSelectedEmail(event.target.value)
    setShowSuggestions(false)
  }

  const handleEmailSelect = (email) => {
    const rememberedUsers = JSON.parse(localStorage.getItem("rememberedUsers")) || []
    const selectedUser = rememberedUsers.find((user) => user.email === email)

    if (selectedUser) {
      setSelectedEmail(selectedUser.email)
      setSelectedPassword(selectedUser.password)
    }
    setShowSuggestions(false)
    setRememberMe(true)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!validateInputs()) {
      return
    }

    const data = new FormData(event.currentTarget)
    const email = selectedEmail || data.get("email")
    const password = selectedPassword || data.get("password")

    const rememberedUsers = JSON.parse(localStorage.getItem("rememberedUsers")) || []

    dispatch(setLoading(true))

    dispatch(login({ email, password }))
      .unwrap()
      .then(() => {
        navigate("/")

        if (rememberMe) {
          const userIndex = rememberedUsers.findIndex((user) => user.email === email)
          if (userIndex === -1) {
            rememberedUsers.push({ email, password })
          } else {
            rememberedUsers[userIndex] = { email, password }
          }
          localStorage.setItem("rememberedUsers", JSON.stringify(rememberedUsers))
        } else {
          const updatedUsers = rememberedUsers.filter((user) => user.email !== email)
          localStorage.setItem("rememberedUsers", JSON.stringify(updatedUsers))
        }
      })
      .catch((error) => {
        console.error("Login failed:", error)
        setPasswordError(true)
        setPasswordErrorMessage(error)
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const validateInputs = () => {
    const email = document.getElementById("email")
    const password = document.getElementById("password")
    let isValid = true

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true)
      setEmailErrorMessage("Please enter a valid email address.")
      isValid = false
    } else {
      setEmailError(false)
      setEmailErrorMessage("")
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true)
      setPasswordErrorMessage("Password must be at least 6 characters long.")
      isValid = false
    } else {
      setPasswordError(false)
      setPasswordErrorMessage("")
    }

    return isValid
  }

  if (isLoggedIn) {
    return <Navigate to="/" />
  }

  return (
    <Grid sx={{ display: "flex", width: "100%" }}>
      <CssBaseline enableColorScheme />
      {/* <ColorModeSelect sx={{ position: "fixed", top: "1rem", right: "1rem" }} /> */}

      <Box
        sx={{
          width: "50%",
          backgroundColor: "rgb(139, 235, 166)",
          display: { xs: "none", sm: "flex" },
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <img src={signinleft} alt="logo" style={{ zIndex: 1, marginBottom: "20px", width: "450px", height: "400px" }} />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: "20%",
            backgroundImage: `url(${background})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            zIndex: 0,
          }}
        />
      </Box>
      <SignInContainer direction="column" justifyContent="center" alignItems="center" position="relative" sx={{width:{sm:"50%"}}} >
        <Box
          sx={{
            width: { md: 550 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pl: { xs: 3, sm: 0 },
            }}
          >
            <img srcSet={logo} src={logo} alt="logo" width={350} loading="lazy" />
          </Box>
          <Typography component="h5" variant="h4" sx={{ textAlign: "center", mt: 2 }}>
            Welcome to BuilderPluss
          </Typography>

          <Typography component="h1" variant="h4" sx={{ my: 2, paddingLeft: { xs: 5, sm: 0 } }}>
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 2,
              pl: { xs: 5, sm: 0 },
              pr: { xs: 5, sm: 0 },
            }}
          >
            <FormControl>
              <FormLabel htmlFor="email" sx={{ textAlign: "start", paddingBottom: "8px", color: "black", fontWeight: "600" }}>
                Email ID
              </FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                value={selectedEmail}
                placeholder="info@builderPluss.com"
                autoComplete="email"
                // autoFocus
                required
                fullWidth
                color={emailError ? "error" : "primary"}
                onFocus={handleEmailFocus}
                onChange={handleEmailChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    color: "black",
                  },
                }}
              />

              {/* suggestions for multi user */}
              {showSuggestions && suggestions.length > 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    boxShadow: 2,
                    maxHeight: "150px",
                    overflowY: "auto",
                    zIndex: 1000,
                    borderRadius: "8px",
                    top: "100%",
                    left: 0,
                  }}
                >
                  {suggestions.map((email, index) => (
                    <Box
                      key={index}
                      sx={{
                        padding: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEmailSelect(email)}
                    >
                      {email}
                    </Box>
                  ))}
                </Box>
              )}
            </FormControl>

            <FormControl>
              <FormLabel htmlFor="password" sx={{ textAlign: "start", paddingBottom: "8px", color: "black", fontWeight: "600" }}>
                Password
              </FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                value={selectedPassword}
                placeholder="••••••"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "black",
                    background: "white",
                  },
                }}
                required
                fullWidth
                // variant="outlined"
                color={passwordError ? "error" : "primary"}
                onChange={handlePassChange}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="end">{showPassword ? <Visibility sx={{ cursor: "pointer" }} onClick={handleClickShowPassword} /> : <VisibilityOff sx={{ cursor: "pointer" }} onClick={handleClickShowPassword} />}</InputAdornment>,
                  },
                }}
              />
            </FormControl>

            <FormControlLabel
              control={<Checkbox checked={rememberMe} onChange={handleCheckboxChange} sx={{ backgroundColor: "limegreen" }} />}
              label="Remember me"
              sx={{
                "& .MuiCheckbox-root": {
                  backgroundColor: "white",
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              onClick={validateInputs}
              sx={{
                backgroundColor: "#2FB354",
                color: "white",
                "&:hover": { backgroundColor: "#2FB354" },
              }}
            >
              Sign in
            </Button>
          </Box>
          <ForgotPassword open={open} handleClose={handleClose} />
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"} my={3}>
            <Link onClick={handleClickOpen} style={{ textDecoration: "none", color: "red", cursor: "pointer" }}>
              Forgot your password?
            </Link>
          </Box>
          <Typography sx={{ position: { md: "absolute", xs: "static" }, left: { xs: "none", md: "50%" }, transform: { md: "translateX(-50%)" }, bottom: { md: 20 }, color: "grey", width: { xs: "100%" }, textAlign: "center" }}>Copyright © 2025 Builder Pluss. All Rights Reserved </Typography>
        </Box>
      </SignInContainer>
    </Grid>
  )
}
